import {AI} from 'Constants/ActionTypes';

const {
  GET_WORD_STRATEGY_ID_OPTIONS,
  SET_QUESTION_STUDY_SEARCH_DATA,
  SET_QUESTION_STUDY_TAB_ACTIVE_KEY,
  GET_QUESTION_STUDY_LIST,
  SET_QUESTION_STUDY_PAGE_STATUS,
  SET_QUESTION_STUDY_STUDY,
  SET_QUESTION_STUDY_IGNORE,
  GET_QUESTION_STUDY_DETAIL_DRAWER_DATA,
} = AI;
// 通用前缀
const url = '/robot';

const actions = {
  // AI优化-问题学习-话术名称下拉框
  getWordStrategyIdOptions() {
    return {
      type: GET_WORD_STRATEGY_ID_OPTIONS,
      payload: {
        request: {
          method: 'get',
          url: `${url}/strategy/select`,
        },
      },
    };
  },
  // AI优化-问题学习-设置搜索条件
  setSearchData(data) {
    return {
      type: SET_QUESTION_STUDY_SEARCH_DATA,
      data,
    };
  },
  // AI优化-问题学习-设置tab的activeKey
  setTabActiveKey(data) {
    return {
      type: SET_QUESTION_STUDY_TAB_ACTIVE_KEY,
      data,
    };
  },
  // AI优化-问题学习-列表
  getTableList(data) {
    return {
      type: GET_QUESTION_STUDY_LIST,
      payload: {
        request: {
          method: 'post',
          url: `${url}/unknown/question/list`,
          data,
        },
      },
    };
  },
  // AI优化-问题学习-设置pageNum与pageSize
  setPageStatus(data) {
    return {
      type: SET_QUESTION_STUDY_PAGE_STATUS,
      data,
    };
  },
  // AI优化-问题学习-学习
  study(id) {
    return {
      type: SET_QUESTION_STUDY_STUDY,
      payload: {
        request: {
          method: 'get',
          url: `${url}/unknown/question/learn/${id}`,
        },
      },
    };
  },
  // AI优化-问题学习-忽略
  ignore(id) {
    return {
      type: SET_QUESTION_STUDY_IGNORE,
      payload: {
        request: {
          method: 'get',
          url: `${url}/unknown/question/ignore/${id}`,
        },
      },
    };
  },
  // AI优化-问题学习-查看详情-通话详情抽屉数据
  getDetailDrawerData(id) {
    return {
      type: GET_QUESTION_STUDY_DETAIL_DRAWER_DATA,
      payload: {
        request: {
          method: 'get',
          url: `${url}/taskinfo/detail/${id}`,
        },
      },
    };
  },
};

export default actions;
